function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
// TODO remove this and do a breaking change on Search to `useImperativeHandle`
// to support controlled/uncontrolled behavior
export function useSearch(_ref) {
  var _ref$onChange = _ref.onChange,
    externalOnChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onClear = _ref.onClear,
    onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue;
  var _React$useState = React.useState(initialValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  React.useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  var isEmpty = value === '';
  function clear() {
    setValue('');
    onChange({
      target: {
        value: ''
      }
    });
    onClear();
  }
  function submit() {
    onSubmit(value);
  }
  function onChange(e) {
    setValue(e.target.value);
    externalOnChange(e);
  }
  function onKeyDown(e) {
    if (e.key === 'Enter') {
      submit();
    } else if (e.key === 'Escape' || e.key === 'Esc') {
      // only let parent listeners (modal, overlay) know when empty
      if (value) {
        e.stopPropagation();
      }
      clear();
    }
  }
  return {
    clear: clear,
    domHandlers: {
      onChange: onChange,
      onKeyDown: onKeyDown
    },
    isEmpty: isEmpty,
    submit: submit,
    value: value
  };
}
//# sourceMappingURL=Search.hooks.js.map